<div>
  <mat-card>
    <mat-progress-bar *ngIf="inProgres" mode="indeterminate"></mat-progress-bar><br>
    <mat-card-title style="display: inline;margin-left: 10px">{{'admin-login.title'|translate}}</mat-card-title>
    <button routerLink="/home" style="display: inline; margin-left: 80%; font-size: 17px" mat-button>{{'admin-login.button-home'|translate}}</button>
    <br><br><br><br>
    <mat-form-field style="width: 80%; margin-left: 10%">
      <input matInput #box [value]="credential" placeholder="{{'admin-login.credential-placeholder'|translate}}" required>
    </mat-form-field>
    <br><br>
    <button (keyup.enter)="doLogIn(box)" (click)="doLogIn(box)"
            style="width: 80%; margin-left: 10%; display: inline" mat-raised-button color="primary">{{'admin-login.button-login'|translate}}</button>
  </mat-card>
</div>
